import { Component, inject } from '@angular/core';
import { SapMaterialTypeService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SapMaterialTypeCreateDto,
  SapMaterialTypeDto,
  SapMaterialTypeExcelDownloadDto,
  SapMaterialTypeUpdateDto,
} from '../proxy/controlling/dtos/sap-material-type';
import { SAPMATERIALTYPE_CONFIG, SAPMATERIALTYPE_FIELDS } from './sap-material-type.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-sap-material-type',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SapMaterialTypeService, ConfirmationService],
  templateUrl: './sap-material-type.html',
  styleUrl: './sap-material-type.scss',
})
export class SapMaterialType extends BaseCrudComponent<
  SapMaterialTypeDto,
  SapMaterialTypeCreateDto,
  SapMaterialTypeUpdateDto,
  SapMaterialTypeExcelDownloadDto
> {
  service = inject(SapMaterialTypeService);
  config = SAPMATERIALTYPE_CONFIG;
  fields = SAPMATERIALTYPE_FIELDS;

  protected prepareUpdateDto(data: any, selected: SapMaterialTypeDto): SapMaterialTypeUpdateDto {
    return {
      sapCode: data.sapCode,
      description: data.description,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SapMaterialType';
  }
}
